'use strict';
module.exports = function arrayWithUniqueElements(array) {
	if (!Array.isArray(array)) {
		return [];
	}
	return Array.from(new Set(array));
};
